// Librearias
import React from 'react'
let PropTypes = React.PropTypes
// Modulos
import * as css from './PanelDatos.css'
// Modales
import {
    ModalTrigger,
    ModalHistorial
} from './Modales.jsx'

export class PanelDatos extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            editandoCorreo: false
        }
        this.onClick_editarEmail = (evt) => {
            console.log(evt)
            this.setState({
                editandoCorreo: true
            }, () => {
                this.refInputEmail.focus()
            })
        }
        this.finalizarEdicionEmail = () => {
            this.context.editarEmailContacto(this.refInputEmail.value)
            this.setState({
                editandoCorreo: false
            })
        }
        this.onKeyPress_editarEmail = (evt) => {
            if (evt.key == 'Enter') {
                evt.preventDefault()
                this.finalizarEdicionEmail()
            }
        }
        this.disminuirDotacion = () => {
            let nuevaDotacion = this.props.nomina.dotacionOperadores - 1
            this.context.cambioDotacion(nuevaDotacion)
        }
        this.aumentarDotacion = () => {
            let nuevaDotacion = this.props.nomina.dotacionOperadores + 1
            this.context.cambioDotacion(nuevaDotacion)
        }
    }

    render() {
        return <div className="row">
            <div className="col-sm-3">
                {/* Datos generales del inventario */}
                <div className="panel panel-default">
                    <div className={'panel-heading ' + css.panelDatos_heading}>Inventario</div>
                    <table className={'table table-compact table-striped ' + css.tablaDatos}>
                        <tbody>
                            <tr>
                                <td>Cliente</td><td>{this.props.nomina.cliente_nombreCorto}</td>
                            </tr>
                            <tr>
                                <td>Local</td><td>({this.props.nomina.local_numero}) {this.props.nomina.local_nombre}</td>
                            </tr>
                            <tr>
                                <td>Fecha programada</td><td>{this.props.nomina.inv_fechaProgramadaF}</td>
                            </tr>
                            {this.props.verTodasNominas ?
                                <tr>
                                    <td>Hr. llegada lider</td><td>{this.props.nomina.horaPresentacionLiderF}</td>
                                </tr> :
                                <tr>
                                    <td>Inicio Proceso</td><td>{this.props.nomina.horaPresentacionLiderF}</td>
                                </tr>
                            }
                            {this.props.verTodasNominas ?
                                <tr>
                                    <td>Hr. llegada equipo</td><td>{this.props.nomina.horaPresentacionEquipoF}</td>
                                </tr> :
                                null
                            }
                            {this.props.verTodasNominas ?
                                <tr>
                                    <td>Operadores</td>
                                    <td>
                                        {this.props.nomina.idEstadoNomina === 2 && (this.props.disminuirDotacion || this.props.cambiarDotacion) ?
                                            <span className={"glyphicon glyphicon-minus " + css.disminuir} aria-hidden="true" onClick={() => this.disminuirDotacion()} title="Disminuir Dotación" > </span>
                                            :
                                            null}
                                        {this.props.nomina.dotacionOperadores}
                                        {this.props.nomina.idEstadoNomina === 2 && this.props.cambiarDotacion ?
                                            <span className={"glyphicon glyphicon-plus " + css.aumentar} aria-hidden="true" onClick={() => this.aumentarDotacion()} title="Aumentar Dotación"> </span>
                                            :
                                            null}
                                    </td>
                                </tr>
                                :
                                null
                            }
                            {this.props.verTodasNominas ?
                                <tr>
                                    <td>Total</td>
                                    <td>{this.props.nomina.dotacionTotal}</td>
                                </tr>
                                :
                                null
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="col-sm-4">
                {/* Datos generales del local*/}
                <div className="panel panel-default">
                    <div className={'panel-heading ' + css.panelDatos_heading}>Local</div>
                    <table className={'table table-compact ' + css.tablaDatos}>
                        <tbody>
                            <tr>
                                <td>Dirección</td>
                                <td>{this.props.nomina.local_direccion}</td>
                            </tr>
                            <tr>
                                <td>Comuna</td>
                                <td>{this.props.nomina.local_comuna}</td>
                            </tr>
                            <tr>
                                <td>Región</td>
                                <td>{this.props.nomina.local_region}</td>
                            </tr>
                            <tr>
                                <td>Formato</td>
                                <td>{this.props.nomina.local_formato}</td>
                            </tr>
                            <tr>
                                <td>Horario</td>
                                <td>Apertura: {this.props.nomina.local_horaAperturaF}  Cierre: {this.props.nomina.local_horaCierreF}</td>
                            </tr>
                            <tr>
                                <td>Teléfonos</td><td>{this.props.nomina.local_telefono1} {this.props.nomina.local_telefono2}</td>
                            </tr>
                            <tr>
                                <td>Correo</td>
                                <td>{this.state.editandoCorreo ?
                                    <input type="text" className={css.inputEmail} ref={ref => this.refInputEmail = ref}
                                        defaultValue={this.props.nomina.local_emailContacto}
                                        onBlur={this.finalizarEdicionEmail.bind(this)}
                                        onKeyPress={this.onKeyPress_editarEmail}
                                    />
                                    :
                                    <div>
                                        {this.props.nomina.local_emailContacto}
                                        <a href="#" onClick={this.onClick_editarEmail.bind(this)}>
                                            <span className="glyphicon glyphicon-edit pull-right"></span>
                                        </a>
                                    </div>
                                }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="col-sm-3">
                {/* Datos generales de Nomina y Stock*/}
                <div className="panel panel-default">
                    <div className={'panel-heading ' + css.panelDatos_heading}>Nómina</div>
                    <table className={'table table-compact ' + css.tablaDatos}>
                        <tbody>
                            <tr>
                                <td>Turno</td>
                                <td>{this.props.nomina.turno}</td>
                            </tr>
                            {this.props.verTodasNominas ?
                                <tr>
                                    <td>Excel</td>
                                    <td><a href={`/programacionIG/nomina/${this.props.nomina.idNominaPublica}/excel`}
                                        className="btn btn-xs">Descargar</a></td>
                                </tr>
                                :
                                null
                            }
                            {this.props.verTodasNominas ?
                                <tr>
                                    <td>Excel Cliente</td>
                                    <td><a href={`/api/nominas/clientes/${this.props.nomina.idNominaPublica}`}
                                        className="btn btn-xs">Descargar</a></td>
                                </tr>
                                :
                                null
                            }
                            {this.props.verTodasNominas ?
                                <tr>
                                    <td>1ra Nómina informada</td>
                                    <td><a href={`/programacionIG/nomina/${this.props.nomina.idNominaPublica}/1ra-nomina`}
                                        className="btn btn-xs">Descargar</a></td>
                                </tr>
                                :
                                null
                            }
                            {this.props.verTodasNominas ?
                                <tr>
                                    <td>PDF</td>
                                    <td><a href={`/programacionIG/nomina/${this.props.nomina.idNominaPublica}/pdfLocalSIG`} className="btn btn-xs">Descargar</a></td>
                                </tr>
                                :
                                null
                            }
                            {this.props.verHistorialNomina && this.props.nomina.idEstadoNomina === 5 ?
                                <tr>
                                    <td>Planilla Cod19</td>
                                    <td><a href={`/api/covid/permission/excel-download-list?idList=${this.props.nomina.idNomina}`} className="btn btn-xs">Descargar</a></td>
                                </tr>
                                :
                                null
                            }
                            {this.props.verHistorialNomina ?
                                <tr>
                                    <td>Historial</td>
                                    <td>
                                        <BotonHistorial
                                            nomina={this.props.nomina}
                                        />
                                    </td>
                                </tr>
                                :
                                null
                            }
                            {this.props.verTodasNomina ?
                                <tr>
                                    <td>Ultimo envío</td>
                                    <td>{this.props.nomina.lastDeliveryByEmail ? this.props.nomina.lastDeliveryByEmail.created_at : 'Nunca enviada'}</td>
                                </tr>
                                :
                                null
                            }

                        </tbody>
                    </table>
                </div>
                {this.props.verTodasNominas ?
                    <div className="panel panel-default">
                        <div className={'panel-heading ' + css.panelDatos_heading}>Stock</div>
                        <table className={'table table-compact ' + css.tablaDatos}>
                            <tbody>
                                <tr>
                                    <td>Informado</td>
                                    <td>{this.props.nomina.local_stock}</td>
                                </tr>
                                <tr>
                                    <td>Fecha Stock</td>
                                    <td>{this.props.nomina.local_fechaStock}</td>
                                </tr>
                                {this.props.nomina.idCliente == 1 || this.props.nomina.idCliente == 5 || this.props.nomina.idCliente == 2 || this.props.nomina.idCliente == 12 ?
                                    <tr>
                                        <td>Sugerido</td>
                                        <td>{this.props.nomina.local_stock_sugerido}</td>
                                    </tr>
                                    : <tr></tr>}
                            </tbody>
                        </table>
                    </div>
                    :
                    <div></div>
                }
            </div>

            <section className="col-sm-2">
                <div className="panel panel-primary">
                    <div className={'panel-heading ' + css.panelDatos_heading}>Lider</div>
                    {this.props.nomina.lider && this.props.nomina.lider.imagenPerfil ?
                        <img className={"img-responsive center-block"}
                            src={`/imagenPerfil/${this.props.nomina.lider.imagenPerfil}`} alt="" />
                        :
                        <p>Sin imagen</p>
                    }
                </div>
            </section>
        </div>
    }

}
PanelDatos.propTypes = {
    nomina: PropTypes.object.isRequired
}
PanelDatos.contextTypes = {
    editarEmailContacto: PropTypes.func,
    cambioDotacion: PropTypes.func
}
const BotonHistorial = ({ nomina }) =>
    <ModalTrigger>
        {(isVisible, showModal, hideModal) =>
            <button className="btn btn-xs btn-info" onClick={showModal}>
                <span className={'glyphicon glyphicon-list-alt'}></span>
                {isVisible && <ModalHistorial
                    hideModal={hideModal}
                    nomina={nomina}
                />}
            </button>
        }
    </ModalTrigger>


// WEBPACK FOOTER //
// ./frontEnd/nominas/nominaIG/components/PanelDatos.jsx